import RestService from './RestService'

export default class AppTemplateService extends RestService {
    constructor() {
        super('templates')
    }

    createApp(appTemplateId) {
        let url = this.baseUrl + '/api/v1/templates/' + appTemplateId + '/app?t=' + Date.now()
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }
}